
function onmenu(type){ 
	if (type=='add') {
		$('.topnav').addClass('topnav-on');
		$('.topnav').after("<div class='topnav-bg' onclick=onmenu('remove')></div>");
	}
	if (type=='remove') {
		$('.topnav').removeClass('topnav-on');
		$(".topnav-bg").remove();
	}
}

function onrow(classname){
	$(classname).toggle();
}

//FAQ大类切换

function faqonqh(classname){
	$(classname).toggle();
}

//生成一个随机数字
function sj() {
    //x上限，y下限     
    var x = 9;
    var y = 1;
    var rand = parseInt(Math.random() * (x - y + 1) + y);
    $("#sjsz").html("").append(rand);
}


//产品页面生成一个随机订单数
function sjorders(code) {
    var now = new Date();
    var date = new Date();

	now.getYear(); //获取当前年份(2位)
	now.getFullYear(); //获取完整的年份(4位)
	now.getMonth(); //获取当前月份(0-11,0代表1月)
	now.getDate(); //获取当前日(1-31)

	var code_int = parseInt(code.substring(code.length-4)); //截取字符串后四位并转为数字类型


    sde = now.getFullYear() + now.getYear() + now.getMonth() + now.getDate() + code_int;
    $('.ordersl').html(sde +' orders');
}


//弹出优惠券提示框
function qjtcc() {

	var qjtcc_html  ='<div class="qj-tcc">'
     	qjtcc_html +='	<div class="yhj-kj">'
     	qjtcc_html +='		<h1>Congrats!!</h1>'
     	qjtcc_html +='		<p>A coupon code just for you</p>'
     	qjtcc_html +='		<div class="hy_k">WHITE18<div class="jiandao"></div>'
     	qjtcc_html +='	</div>'
     	qjtcc_html +='	<span>Only <font color="#e71b32">2</font>/100 left available, apply it when you checkout</span>'
     	qjtcc_html +='	<i onclick="qjtcc_off()">&#xe727;</i>'
     	qjtcc_html +='	</div>'
     	qjtcc_html +='</div>'
	$("body").append(qjtcc_html);
  
	setTimeout(function(){
		$(".qj-tcc").css("opacity","1");
	},500);
}
//关闭弹出优惠券提示框
function qjtcc_off() {
	$(".qj-tcc").css("opacity","0");
	setTimeout(function(){
		$(".qj-tcc").remove();
	},500);

}



//弹出优惠券提示框-图片模式
function tccimg() { 
	var qjtcc_html  ='<div class="ad-tcc">'
		qjtcc_html +='	<div class="ad-kj" style="background-image: url(https://cdn.shopify.com/s/files/1/0061/0746/3762/files/white-day-TGH-800-430.jpg?v=1);">'
		qjtcc_html +='	    <i onclick="tccimg_off()">&#xe727;</i>'
		qjtcc_html +='	</div>'
		qjtcc_html +='	<div class="ad-bg" onclick="tccimg_off()"></div>'
		qjtcc_html +='</div>'
	$("body").append(qjtcc_html);
  
	setTimeout(function(){
		$(".ad-tcc").css("opacity","1");
	},300);
}

//关闭弹出优惠券提示框-图片模式
function tccimg_off() {
	$(".ad-tcc").css("opacity","0");
	setTimeout(function(){
		$(".ad-tcc").remove();
	},300);

}



//弹出搜索
function tccsoso() { 
	var qjtcc_html  ='<div class="soso-tcc">'
		qjtcc_html +='	<div class="soso-kj">'
		qjtcc_html +='		<div class="sotitle">search</div>'
		qjtcc_html +='		<div class="sowbk">'
		qjtcc_html +='			<form action="/search" method="get">'
		qjtcc_html +='				<input type="hidden" name="type" value="product">'
		qjtcc_html +='				<input id="sosuoPC" type="text" name="q" placeholder="Enter your search terms" style="margin-bottom:0;" autocomplete="off" onkeydown="if(event.keyCode==13){gosubmit("SOPC");}">'
		qjtcc_html +='				<button type="submit" title="Search"><i class="fa fa-search"></i></button>'
		qjtcc_html +='			</form>'     
		qjtcc_html +='		</div>'
		qjtcc_html +='		<i onclick="tccsoso_off()">&#xe727;</i>'
		qjtcc_html +='	</div>'
		qjtcc_html +='	<div onclick="tccsoso_off()" class="soso-bg"></div>'
		qjtcc_html +='</div>'
	$("body").append(qjtcc_html);
  
	setTimeout(function(){
		$(".soso-tcc").css("opacity","1");
	},300);
}

//关闭弹出搜索
function tccsoso_off() {
	$(".soso-tcc").css("opacity","0");
	setTimeout(function(){
		$(".soso-tcc").remove();
	},300);

}

//打开尺寸说明
function seelg_on() {
	var qjtcc_html  ='<div class="qj-tcc">'
     	qjtcc_html +='	<div class="seelg-kj">'
     	qjtcc_html +='		<img src="https://cdn.shopify.com/s/files/1/0061/0746/3762/files/QDT.jpg?1286">'
     	qjtcc_html +='		<i onclick="qjtcc_off()">&#xe727;</i>'
     	qjtcc_html +='	</div>'
     	qjtcc_html +='</div>'
    $("body").append(qjtcc_html);
	setTimeout(function(){
		$(".qj-tcc").css("opacity","1");
	},100);
}



$(function() {
	//FAQ
	$(".faqs_content > ul > li > p").click(function(){
	  $(this).siblings('.zlm').toggle();
	});

	$(".faqs_content > ul > li > .zlm > p").click(function(){
	  $('.span').hide();
	  $(this).siblings('.span').toggle();
	});

	//导航栏
	$(".n_t").mouseover(function(){
	  $(this).find('ul').addClass('ul-hover');
	});

	//导航栏
	$(".n_t").mouseout(function(){
	  $(this).find('ul').removeClass('ul-hover');
	});

	//生成一个随机数字
	sj();
  
  

	//定时弹出优惠券提示框,时间是随机生成的数字
    var x = 10000;
    var y = 50000;
    var rand = parseInt(Math.random() * (x - y + 1) + y);  
	setTimeout(function(){
		//qjtcc();
		//tccimg();
	},rand);


    
})

//滚动条监控事件
$(document).scroll(function() {
	var scroH = $(document).scrollTop();  //滚动高度
	var viewH = $(window).height();  //可见高度 
	var contentH = $(document).height();  //内容高度

	if(scroH >150){  //距离顶部大于100px时
		$(".h-menu").addClass("topbrow-td")
	}
	if(scroH <150){  //距离顶部大于100px时
		$(".h-menu").removeClass("topbrow-td");
	}
	//if (contentH - (scroH + viewH) <= 100){}  //距离底部高度小于100px
	  
	//if (contentH = (scroH + viewH)){}   //滚动条滑到底部啦		 	 

});


//wap端导航菜单
function wap_menu(e){
	if(e=='on'){
		$(".wap-menu-bg").fadeIn()
		$(".wap-menu").css('left','0');
	}
	if(e=='off'){

		$(".wap-menu").css('left','-60%');
		$(".wap-menu-bg").fadeOut()
	}
}